module.exports = __webpack_public_path__ + "static/media/Brands_4.65a115d0.png";